









import Vue from 'vue'
import { SpellCollection } from '@/types'
import SpellBookEntry from '@/components/SpellBookEntry.vue'

export default Vue.extend({
  name: 'SpellBookView',
  computed: {
    spells (): SpellCollection {
      return this.$store.state.spellBook
    },
    showEmptyState (): boolean {
      return Object.keys(this.spells).length === 0
    },
  },
  components: {
    SpellBookEntry,
  },
})
